import { createContext, useContext } from 'react';

export const GeonorgeContext = createContext(null);

export const useGeonorge = () => {
  const context = useContext(GeonorgeContext);
  if (context == null) {
    throw new Error('useGeonorge must be used within a GeonorgeProvider');
  }
  return context;
};
